<template>
  <div class="subscription-level">
    <img v-if="active === true" class="subscription-icon" src="/static/img/bookmark.svg">
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'subscription-level',

    props: ['subscriptions'],

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed: {
      active: function() {
        if(this.subscriptions && this.subscriptions.length > 0) {
          for(let i in this.subscriptions) {
            console.log('this.subscriptions[i].subscriptionTermMonths', this.subscriptions[i].subscriptionTermMonths);
            let startDate = moment(this.subscriptions[i].createdAt);
            let endDate = moment(this.subscriptions[i].createdAt).add(this.subscriptions[i].subscriptionTermMonths, 'months');

            console.log('startDate', startDate.format());
            console.log('endDate', endDate.format());

            if (endDate.isSameOrAfter(moment())) {
              return true;
            }
          }
        }

        return false;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .subscription-icon {
    height: 1.8rem;
    width: 1.8rem;
  }
</style>



// WEBPACK FOOTER //
// SubscriptionLevel.vue?bc266944